/* unplugin-vue-components disabled */import script from "./VideoView.vue?vue&type=script&lang=ts&setup=true"
export * from "./VideoView.vue?vue&type=script&lang=ts&setup=true"

import "./VideoView.vue?vue&type=style&index=0&id=7925ffe9&lang=css"
import "./VideoView.vue?vue&type=style&index=1&id=7925ffe9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7925ffe9"]])

export default __exports__